export default {
    props: {
        schemaAxes: {
            type: [Function, String],
            default: undefined,
            kComposite: 'schema.axes'
        }, 
        schemaCatalogs: {
            type: [Function, String],
            default: undefined,
            kComposite: 'schema.catalogs'
        }, 
        schemaCubes: {
            type: [Function, String],
            default: undefined,
            kComposite: 'schema.cubes'
        }, 
        schemaCube: {
            type: Object,
            default: undefined,
            kComposite: 'schema.cube'
        }, 
        schemaData: {
            type: [Function, String],
            default: undefined,
            kComposite: 'schema.data'
        }, 
        schemaDimensions: {
            type: [Function, String],
            default: undefined,
            kComposite: 'schema.dimensions'
        }, 
        schemaHierarchies: {
            type: [Function, String],
            default: undefined,
            kComposite: 'schema.hierarchies'
        }, 
        schemaLevels: {
            type: [Function, String],
            default: undefined,
            kComposite: 'schema.levels'
        }, 
        schemaMeasures: {
            type: [Function, String],
            default: undefined,
            kComposite: 'schema.measures'
        },
        schemaAggregates: {
            type: [Function, String],
            default: undefined,
            kComposite: 'schema.aggregates'
        },
        schemaErrors: {
            type: [Function, String],
            default: undefined,
            kComposite: 'schema.errors'
        },
        schemaGroups: {
            type: [Function, String],
            default: undefined,
            kComposite: 'schema.groups'
        },
        schemaModelId: {
            type: String,
            default: undefined,
            kComposite: 'schema.model.id'
        },
        schemaModelFields: {
            type: Object,
            default: undefined,
            kComposite: 'schema.model.fields'
        },
        schemaParse: {
            type: Function,
            default: undefined,
            kComposite: 'schema.parse'
        },
        schemaTotal: {
            type: [Function, String],
            default: undefined,
            kComposite: 'schema.total'
        },
        schemaType: {
            type: String,
            default: undefined,
            kComposite: 'schema.type'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-datasource-vue-wrapper/src/KendoPivotDataSource/Schema.js